import { withProps } from 'recompose';
import config from '../../config';

export default withProps({
  urlPattern: config.urlPatterns.barber,
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithBarberUrlPattern.js